/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ jobs: NonNullable<unknown>, stamps: NonNullable<unknown> }} Import_Feed_Loaded_StampsInputs */

const cs_import_feed_loaded_stamps = /** @type {(inputs: Import_Feed_Loaded_StampsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Načteno z feedu: ${i?.jobs} z ${i?.stamps} nabídek`)
};

const en_import_feed_loaded_stamps = /** @type {(inputs: Import_Feed_Loaded_StampsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Loaded from feed: ${i?.jobs} of ${i?.stamps} offers`)
};

/**
* | output |
* | --- |
* | "Loaded from feed: {jobs} of {stamps} offers" |
*
* @param {Import_Feed_Loaded_StampsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_loaded_stamps = /** @type {((inputs: Import_Feed_Loaded_StampsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Loaded_StampsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_loaded_stamps(inputs)
	return cs_import_feed_loaded_stamps(inputs)
});